import PasswordRules from './PasswordRules';
import Modal from '../UI/Modal/Modal';

const PasswordRulesModal = (props) => {
    return(
        <Modal onClose={props.onClose}><PasswordRules idPrefix='modal'/></Modal>
    );
};

export default PasswordRulesModal;